<template>
  <div class="product-zone-container">
    <div class="category-scroll-wrapper">
      <div class="category-scroll-track">
        <div 
          v-for="(category, index) in categoryList" 
          :key="index" 
          class="category-item"
          :class="{ active: activeCategory === category.id }"
          @click="handleCategoryClick(category)"
        >
          {{ category.name }}
        </div>
      </div>
    </div>
    
    <div class="product-grids" v-if="activeCategory == 'recommend'">
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>
      <div v-else-if="goodsList.length === 0" class="empty-container">
        <div class="empty-icon">📦</div>
        <div class="empty-text">暂无商品</div>
      </div>
      <GoodsLst v-else :good-list="goodsList" :is-sort="false"></GoodsLst>
    </div>
    <div class="product-grids" v-else>
      <div v-if="loading" class="loading-container">
        <div class="loading-spinner"></div>
        <div class="loading-text">加载中...</div>
      </div>
      <div v-else-if="goodsList1.length === 0" class="empty-container">
        <div class="empty-icon">📦</div>
        <div class="empty-text">暂无商品</div>
      </div>
      <GoodsLst v-else :good-list="goodsList1" :is-sort="false"></GoodsLst>
    </div>
  </div>
</template>

<script>
import GoodsLst from "@components/GoodsLst";
import { getGroomList } from "@api/store";
import { getProducts } from "@api/store";
export default {
  name: 'ProductZone',
   components: {
    GoodsLst,
  },
  data() {
    return {
      activeCategory: 'recommend',
      goodsList: [],
      goodsList1: [],
      loading: false,
      categoryList: [
        { id: 'recommend', name: '重点推荐' },
        { id: '9', name: '品质家电' },
        { id: '178,177,59,34,61', name: '影音数码' },
        { id: '6', name: '家居日用' },
        { id: '15', name: '美妆护肤' },
        { id: '16', name: '腕表黄金' }
        
      ],
      
    }
  },
  computed: {
    productList() {
      return this.productMap[this.activeCategory] || []
    }
  },
  mounted() {
    this.getIndexGroomList();
  },
  methods: {
    getIndexGroomList: function() {
      console.log(this.activeCategory);
      let that = this;
      that.loading = true;
      
      // console.log(type);
      getGroomList(1)
        .then((res) => {
          // that.imgUrls = res.data.banner;
          that.goodsList = res.data.list;
          that.loading = false;
          console.log(res.data.list);
        })
        .catch(function(res) {
          that.loading = false;
          this.$dialog.toast({ mes: res.msg });
        });
    },
    getIndexGroomList1: function() {
      this.goodsList1 = [];
      console.log(this.activeCategory);
      let that = this;
      let arr = this.activeCategory.split(',');
      // this.activeCategory = arr[i];
      for(let i=0;i<arr.length;i++){
        
        let q = {
        sid: arr[i],
        page: 1,
        limit: 99,
      };
      getProducts(q).then((res) => {
        that.loading = false;
        that.goodsList1.push(...res.data);//判断所有数据是否加载完成；
      });
      }
      
    },
    handleProductClick(product) {
      this.$emit('productClick', product)
    },
    handleCategoryClick(category) {
      console.log(category);
      
      this.loading = true;
      if(category.id === 'recommend'){
        this.activeCategory = category.id;
        this.$emit('categoryChange', category);
        this.getIndexGroomList();
        return;
      }
      this.activeCategory = category.id
      this.$emit('categoryChange', category)
      this.getIndexGroomList1(category.id);
    }
  }
}
</script>

<style lang="scss" scoped>
.product-zone-container {
  background: #fff;
  padding: 0.3rem;
  margin-top: 0.2rem;
}

.zone-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.2rem;
  
  .header-content {
    display: flex;
    flex-direction: column;
  }
  
  .header-title {
    font-size: 0.32rem;
    font-weight: bold;
    color: #333;
  }
  
  .header-subtitle {
    font-size: 0.22rem;
    color: #999;
    margin-top: 0.08rem;
  }
  
  .header-more {
    font-size: 0.24rem;
    color: #ff4d4f;
  }
}

.category-scroll-wrapper {
  position: sticky;
  top: 0;
  z-index: 100;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  margin-bottom: 0.2rem;
  background: #fff;
  padding: 0.2rem 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  
  &::-webkit-scrollbar {
    display: none;
  }
}

.category-scroll-track {
  display: inline-flex;
  gap: 0.2rem;
  padding: 0.1rem 0;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.loading-spinner {
  width: 0.6rem;
  height: 0.6rem;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #ff4d4f;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-text {
  font-size: 0.24rem;
  color: #999;
  margin-top: 0.2rem;
}

.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.empty-icon {
  font-size: 1rem;
  margin-bottom: 0.2rem;
}

.empty-text {
  font-size: 0.26rem;
  color: #999;
}

.category-item {
  display: inline-block;
  font-size: 0.28rem;
  color: #666;
  padding: 0.15rem 0.3rem;
  background: #f5f5f5;
  border-radius: 0.3rem;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  
  &.active {
    background: #ff4d4f;
    color: #fff;
  }
  
  &:active {
    opacity: 0.7;
  }
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.2rem;
}

.product-card {
  background: #fff;
  border-radius: 0.2rem;
  overflow: hidden;
  
  &:active {
    opacity: 0.9;
  }
}

.product-image {
  width: 100%;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.15rem;
  
  .product-icon {
    font-size: 1rem;
  }
}

.product-tags {
  display: flex;
  gap: 0.1rem;
  margin-top: 0.15rem;
  flex-wrap: wrap;
  
  .tag {
    font-size: 0.18rem;
    padding: 0.06rem 0.12rem;
    border-radius: 0.08rem;
    
    &.hot {
      background: #ff4d4f;
      color: #fff;
    }
    
    &.gift {
      background: #fff2f0;
      color: #ff4d4f;
      border: 1px solid #ffccc7;
    }
    
    &.recommend {
      background: #1890ff;
      color: #fff;
    }
    
    &.feature {
      background: #e6f7ff;
      color: #1890ff;
      border: 1px solid #91d5ff;
    }
    
    &.normal {
      background: #722ed1;
      color: #fff;
    }
    
    &.brand {
      background: #f9f0ff;
      color: #722ed1;
      border: 1px solid #d3adf7;
    }
    
    &.quality {
      background: #f6ffed;
      color: #52c41a;
      border: 1px solid #b7eb8f;
    }
  }
}

.product-name {
  font-size: 0.26rem;
  color: #333;
  font-weight: 500;
  margin-top: 0.1rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-desc {
  font-size: 0.2rem;
  color: #999;
  margin-top: 0.08rem;
}

.product-bottom {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 0.15rem;
}

.price-section {
  display: flex;
  flex-direction: column;
  
  .price-row {
    display: flex;
    align-items: baseline;
  }
  
  .price-symbol {
    font-size: 0.22rem;
    color: #ff4d4f;
    font-weight: bold;
  }
  
  .price-value {
    font-size: 0.32rem;
    color: #ff4d4f;
    font-weight: bold;
  }
  
  .price-note {
    font-size: 0.18rem;
    color: #999;
    margin-top: 0.05rem;
  }
}

.buy-btn {
  border: none;
  border-radius: 0.3rem;
  padding: 0.12rem 0.3rem;
  font-size: 0.22rem;
  color: #fff;
  
  &:active {
    opacity: 0.8;
  }
}

/* 移动端适配 */
@media screen and (max-width: 480px) {
  .product-zone-container {
    padding: 0.25rem;
  }
  
  .product-grid {
    gap: 0.15rem;
  }
  
  .product-image {
    height: 2.2rem;
    
    .product-icon {
      font-size: 0.9rem;
    }
  }
  
  .product-name {
    font-size: 0.24rem;
  }
  
  .product-desc {
    font-size: 0.18rem;
  }
  
  .price-value {
    font-size: 0.28rem;
  }
  
  .buy-btn {
    padding: 0.1rem 0.25rem;
    font-size: 0.2rem;
  }
}
</style>